import React from 'react';
import { PageHeader } from '@/components/layout/PageHeader';
import DashboardBannerCarousel from '@/components/dashboard/DashboardBannerCarousel';

/**
 * DashboardShell — thin page frame shared by every role dashboard.
 *
 * Consolidates the three pieces every role dashboard rendered inline before
 * Phase 20.2:
 *  1. `<div data-testid="dashboard-page">` root (contract with tests)
 *  2. `PageHeader` (title / description / breadcrumbs / actions slot)
 *  3. `.page-content` container (spacing rhythm)
 *
 * This component intentionally does NOT declare any data-loading, role
 * detection, or content — those live inside each role's dashboard component.
 * Purely visual scaffolding.
 */
export const DashboardShell = ({ title, description, actions, children }) => (
  <div data-testid="dashboard-page">
    <PageHeader
      title={title}
      description={description}
      breadcrumbs={[{ label: 'Dashboard', href: '/dashboard' }]}
      actions={actions}
    />
    <div className="page-content">
      <DashboardBannerCarousel />
      {children}
    </div>
  </div>
);

export default DashboardShell;
